module.exports = __webpack_public_path__ + "img/bp01.30661216.jpg";